/**
 * 주일 오전예배 설교 페이지
 */

import React from 'react';
import { SermonList } from '../components/SermonList';

export const SundayMorningSermon: React.FC = () => {
  return <SermonList sermonType="sunday-morning" title="주일 오전예배" />;
};
